import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Typography } from "@mui/material";

export default function AlertDialog({ open, setOpen, onConfirm }) {
	const handleClose = () => {
		setOpen(false);
	};

	return (
		<Dialog
			open={open}
			// onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogTitle
				id="alert-dialog-title"
				sx={{ fontWeight: "bold", fontSize: "1.25rem", textAlign: "center" }}
			>
				<Typography variant="h6">Overwrite Confirmation</Typography>
			</DialogTitle>
			<DialogContent sx={{ padding: "20px 24px" }}>
				<DialogContentText
					id="alert-dialog-description"
					sx={{
						fontSize: "1rem",
						color: "text.secondary",
						textAlign: "center",
					}}
				>
					Saving this content will overwrite the previous data. Do you want to
					save it?
				</DialogContentText>
			</DialogContent>
			<DialogActions sx={{ justifyContent: "right", padding: "16px 24px" }}>
				<Button
					onClick={handleClose}
					color="secondary"
					variant="outlined"
					sx={{ marginRight: 1, fontWeight: "bold" }}
				>
					No
				</Button>
				<Button
					onClick={onConfirm}
					color="primary"
					variant="contained"
					sx={{ fontWeight: "bold" }}
				>
					Yes
				</Button>
			</DialogActions>
		</Dialog>
	);
}
